export default __webpack_public_path__ + "static/media/marker-gray-red.78feb8a5.png";